const addZeroPrefix = (value: number) => `0${value}`.slice(-2);

export default addZeroPrefix;
